/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuMultiSelectList_itemSearch = {
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly localizedFilterName: string | null;
        readonly canBeDismissed: boolean | null;
        readonly values: ReadonlyArray<{
            readonly urlLabel: string | null;
            readonly count: number | null;
            readonly displayName: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": "SbSharedRefineMenuMultiSelectList_itemSearch";
};
export type SbSharedRefineMenuMultiSelectList_itemSearch$data = SbSharedRefineMenuMultiSelectList_itemSearch;
export type SbSharedRefineMenuMultiSelectList_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuMultiSelectList_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuMultiSelectList_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuMultiSelectList_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "kind": "LinkedField",
      "name": "appliedFilters",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "localizedFilterName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canBeDismissed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParamValue",
          "kind": "LinkedField",
          "name": "values",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlLabel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "count",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'ee37345b718c7904636fc5b29df4af5a';
export default node;
